import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'src/extensions/array.extensions';
import 'src/extensions/string.extensions';
import App from './App';
import { AuthProvider } from './components/molecules/AuthProvider/AuthProvider';
import './dayjs';
import './styles/index.scss';
import './wdyr';

const container = document.getElementById('root');

if (!container) throw new Error('Could not get root element');

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 5,
        },
    },
});
const root = createRoot(container);

root.render(
    <StrictMode>
        <AuthProvider>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </AuthProvider>
    </StrictMode>
);
